import React, { ReactNode } from "react";

import Vimeo, { VimeoProps } from "@u-wave/react-vimeo";

import { checkExperienceCookieConsent, useCookieConsent } from "utils";

import { VideoCookieConsentReminder } from "components";

type GatedVimeoProps = VimeoProps & {
  // Rendered in place of the video when Experience cookie consent is missing. Defaults to a reminder card; pass null to render nothing.
  consentFallback?: ReactNode;
};

// Single consent-gated entry point for the Vimeo embed. Vimeo sets "Experience" third-party cookies, so the iframe
// only mounts once the user has accepted that purpose — matching the maps gate and the reminder copy, so accepting
// only "Experience" unlocks videos. All Vimeo usage should go through this wrapper so the gate lives in one place.
export const GatedVimeo = ({ consentFallback = <VideoCookieConsentReminder />, ...props }: GatedVimeoProps) => {
  const hasExperienceCookieConsent = useCookieConsent(checkExperienceCookieConsent);

  if (!hasExperienceCookieConsent) {
    return <>{consentFallback}</>;
  }

  return <Vimeo {...props} />;
};

export default GatedVimeo;
